import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Alert, Box, Button, Chip, Stack, Typography } from "@mui/material";
import { OssChangeList } from "../changes/OssChangeList";

const documentTypeLabel = {
  PURCHASE_ORDER: "발주서",
  ORDER_FORM: "주문서",
  CHANGE_ORDER: "변경 근거",
  SPEC: "규격서",
  OTHER: "기타",
};

export const OssDetailDocumentFlow = ({
  documents = [],
  disabled,
  onUpload,
  onOpen,
  onDelete,
}) => (
  <Stack spacing={1.2} sx={{ p: 1.5 }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
      <Box>
        <Typography sx={{ fontSize: 16, fontWeight: 900, color: "#111827" }}>주문 문서</Typography>
        <Typography sx={{ mt: 0.2, fontSize: 13, color: "#64748b" }}>
          발주서, 변경 근거, 규격서를 주문 품목과 함께 보관합니다.
        </Typography>
      </Box>
      <Button variant="contained" startIcon={<AddRoundedIcon />} disabled={disabled} onClick={onUpload}>
        문서 업로드
      </Button>
    </Stack>

    {documents.length === 0 ? (
      <Box
        sx={{
          minHeight: 170,
          display: "grid",
          placeItems: "center",
          border: "1px dashed #d6d9e4",
          borderRadius: "8px",
          color: "#64748b",
          bgcolor: "#fbfbfe",
        }}
      >
        등록된 문서가 없습니다.
      </Box>
    ) : (
      <Stack spacing={0.8}>
        {documents.map((doc) => (
          <Box
            key={doc.document_id}
            sx={{
              p: 1.2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.2,
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              bgcolor: "#fff",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  display: "grid",
                  placeItems: "center",
                  borderRadius: "8px",
                  bgcolor: "#eef2ff",
                  color: "#6c5ce7",
                }}
              >
                <DescriptionOutlinedIcon fontSize="small" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography noWrap sx={{ fontSize: 14.5, fontWeight: 800, color: "#111827" }}>
                  {doc.file_name}
                </Typography>
                <Stack direction="row" spacing={0.7} alignItems="center" flexWrap="wrap">
                  <Chip size="small" label={documentTypeLabel[doc.document_type] || doc.document_type} variant="outlined" />
                  <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>
                    v{doc.version_no} · {doc.uploaded_at || "-"}
                  </Typography>
                </Stack>
              </Box>
            </Stack>
            <Stack direction="row" spacing={0.6}>
              <Button size="small" startIcon={<OpenInNewRoundedIcon />} onClick={() => onOpen(doc)}>
                열기
              </Button>
              <Button size="small" color="error" startIcon={<DeleteOutlineRoundedIcon />} onClick={() => onDelete(doc)}>
                삭제
              </Button>
            </Stack>
          </Box>
        ))}
      </Stack>
    )}
  </Stack>
);

export const OssDetailChangeFlow = ({
  changes = [],
  lines = [],
  loading,
  disabled,
  onRequest,
  onReview,
}) => (
  <Stack spacing={1.2} sx={{ p: 1.5 }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
      <Box>
        <Typography sx={{ fontSize: 16, fontWeight: 900, color: "#111827" }}>변경 검토 흐름</Typography>
        <Typography sx={{ mt: 0.2, fontSize: 13, color: "#64748b" }}>
          납기, 수량, 규격 변경 요청을 남기고 승인 시 일정과 위험도를 다시 계산합니다.
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<AddRoundedIcon />}
        disabled={disabled || lines.length === 0}
        onClick={onRequest}
      >
        변경 요청
      </Button>
    </Stack>

    {changes.length === 0 ? (
      <Alert severity="info" sx={{ borderRadius: "8px" }}>
        등록된 변경 요청이 없습니다.
      </Alert>
    ) : (
      <OssChangeList rows={changes} loading={loading} onReview={onReview} />
    )}
  </Stack>
);
